module.exports = __webpack_public_path__ + "static/media/units.38858687.svg";